import Link from "next/link";

function BlogListCard({ data }: any) {
	return (
		<Link className='block' href={`/blogs/${data.slug}`}>
			<img src={data.title_image} alt={data.title} className="h-[200px] object-cover w-full" />
			<p className='text-[22px] md:text-[18px] mt-[20px] text-center leading-[120%]'> {data.title}  </p>
		</Link>
	)
}

export default BlogListCard